var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.rejseplanen = new function () {
    var self = this;
    this.init = function () {
        this.setupRejseplanen();
    };
    this.setupRejseplanen = function () {
        var currentDate = new Date();
        var currentTime = (currentDate.getHours() < 10 ? "0" + currentDate.getHours().toString() : currentDate.getHours().toString()) + ":" +
            (currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes().toString() : currentDate.getMinutes().toString());
        var today = currentDate;
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;

        var autoCompleteOptions = {
            minLength: 2,
            source: function (request, response) {
                $.get('/umbraco/api/RejseplanenApi/GetStops', {
                        'input': request.term,
                        'sync': ''
                    },
                    function (data, status, xhr) {
                        response($.map(data.Stops,
                            function (item) {
                                return {
                                    label: item.Name,
                                    value: item.Name
                                };
                            }));
                    });
            }
        };
        $('#rejseplanen-from').autocomplete(autoCompleteOptions);
        $('#rejseplanen-to').autocomplete(autoCompleteOptions);

        //set initial value
        $('#rejseplanen-date').val(today);
        $('#rejseplanen-time').val(currentTime);

        //rejseplanen search
        $('#search-rejseplan-button').click(function (e) {
            e.stopPropagation();
            var form = $('.frontpage-hero-rejseplanen-form');
            var s = escape($('input[name="S"]', form).val());
            var z = escape($('input[name="Z"]', form).val());
            var date = escape($('input[name="date"]', form).val());
            date = date.split('-');
            date = date[2] + '.' + date[1] + '.' + date[0];
            var time = escape($('input[name="time"]', form).val());
            var timeSel = escape($('input[name="timesel"]:checked', form).val());
            var url = 'https://www.rejseplanen.dk/webapp/index.html#!S|' +
                s +
                '!Z|' +
                z +
                '!date|' +
                date +
                '!time|' +
                time +
                '!timeSel|' +
                timeSel +
                '!start|1';
            window.open(url);
        });
        // jQuery('#rejseplanen-time').datetimepicker({
        //     value: currentTime,
        //     datepicker: false,
        //     format: 'H:i',
        //     onGenerate: function () {
        //         $('.xdsoft_time').removeClass('xdsoft_disabled');
        //         $('td').removeClass('xdsoft_disabled');
        //     }
        // });



        //http://xdsoft.net/jqplugins/datetimepicker/
        // $.datetimepicker.setLocale('da');
        // jQuery('#rejseplanen-date').datetimepicker({

        //     value: today,
        //     timepicker: false,
        //     dayOfWeekStart: 1,
        //     format: 'd.m.Y',
        //     onGenerate: function () {
        //         $('td').removeClass('xdsoft_disabled');
        //     }
        // });
    };
}();